import { motion } from "framer-motion";
import { Mail, MapPin } from "lucide-react";

const ContactSection = () => {
  return (
    <section id="contact" className="contact-section py-24 px-6 bg-background">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left — heading, description, details */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="contact-heading text-3xl md:text-4xl font-heading font-medium text-foreground mb-4">
              Ready to Begin?
            </h2>
            <div className="w-16 h-px bg-accent mb-8" />
            <p className="font-body text-muted-foreground font-light leading-relaxed mb-10">
              You've already done the hardest part — looking for support. Reach out to schedule a free consultation, ask a question, or simply introduce yourself. There's no pressure, no commitment — just a conversation.
            </p>

            <div className="contact-details flex flex-col gap-4 text-muted-foreground font-body text-sm">
              <div className="contact-location flex items-center gap-3">
                <MapPin className="w-4 h-4 text-accent" strokeWidth={1.5} />
                <span>Dallas, TX</span>
              </div>
              <div className="contact-email flex items-center gap-3">
                <Mail className="w-4 h-4 text-accent" strokeWidth={1.5} />
                <span>ashley@stillwatertherapy.com</span>
              </div>
            </div>
          </motion.div>

          {/* Right — CTA */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex flex-col items-center md:items-start gap-4"
          >
            <a
              href="https://ashley-bass.clientsecure.me/request/service"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-cta w-full md:w-auto text-center bg-primary text-primary-foreground px-10 py-4 rounded-md font-body font-medium tracking-wider text-sm uppercase hover:opacity-90 transition-opacity"
            >
              Get Started
            </a>
            <a
              href="mailto:ashley@stillwatertherapy.com"
              className="w-full md:w-auto text-center border border-border text-foreground px-10 py-4 rounded-md font-body font-medium tracking-wider text-sm uppercase hover:bg-secondary transition-colors"
            >
              Contact Us
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
